import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class OrderLogService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getOrderLog(gridData, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/order-log/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
